module.exports = __webpack_public_path__ + "media/images/games/fifa-23/rectangle-4cf32694feb4e4d790ba38e794c3de4a.jpg";